import React from 'react';
import PropTypes from 'prop-types';
import AttachmentPreviewModal, {
  attachmentTypeIconRenderer,
} from '../common/AttachmentPreviewModal/AttachmentPreviewModal';

export const StudentAttachmentFile = ({
  submission,
  student,
  withLabel,
  color,
}) => {
  const studentAttachment = submission && submission.attachment;

  return studentAttachment ? (
    <AttachmentPreviewModal
      testId={'attachment-preview-modal'}
      title={studentAttachment.fileName}
      loading={false}
      buttonTextCancel={'Close'}
      attachment={studentAttachment}
      renderProp={setPreviewModal =>
        withLabel ? (
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            {attachmentTypeIconRenderer(
              setPreviewModal,
              studentAttachment,
              student.name,
              withLabel,
              color,
            )}
          </div>
        ) : (
          attachmentTypeIconRenderer(
            setPreviewModal,
            studentAttachment,
            student.name,
            withLabel,
            color,
          )
        )
      }
    />
  ) : null;
};

StudentAttachmentFile.defaultProps = {
  submission: null,
  withLabel: false,
  color: '#4DC9C5',
};

StudentAttachmentFile.propTypes = {
  submission: PropTypes.object,
  withLabel: PropTypes.bool,
  student: PropTypes.object.isRequired,
  color: PropTypes.string,
};
